export const APPLICATION_LOGS_VIEW = "LeninkaArt.ApplicationLogs.View"
